import React from "react";
import "./index.css";
import logo from "../../assets/whitelogo.svg"
import { Button } from "../Button/index"
import { Input } from "../Input/index"
import Android from "../../assets/android.svg"
import Apple from "../../assets/apple.svg"
export const Footer = () => {
    return (
        <footer className="my-2 footer-bg">
            <br />
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className="row">
                        <div className="col-md-3">
                            <img src={logo} />
                        </div>
                        <div className="col-md-3">
                            <h4>For Customers</h4>
                            <div>
                                <div className="py-2">Find Artisans</div>
                                <div className="py-2">How it Works</div>
                                <div className="py-2">Safe & Trust</div>
                                <div className="py-2">Help Center</div>

                            </div>
                        </div>
                        <div className="col-md-3">
                            <h4>For Artisans</h4>
                            <div>
                                <div className="py-2">Find Artisans</div>
                                <div className="py-2">How it Works</div>
                                <div className="py-2">Safe & Trust</div>
                                <div className="py-2">Help Center</div>

                            </div>
                        </div>
                        <div className="col-md-3">
                            <h4>Company</h4>
                            <div>
                                <div className="py-2">Privacy Policy</div>
                                <div className="py-2">Terms of Use</div>
                                <div className="py-2">Terms & Conditions</div>
                                <div className="py-2">Help Center</div>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-4 col-12">
                    <div className="pt-3">
                        <Input className="input-className" style={{ width: '100%' }} placeholder='Email Address' />
                        <Button className="primary-button mt-3 w-100" style={{background:'white', color:'#133253'}} text="Join Waitlist" />
                    </div>
                    <br />
                    <div className="d-flex align-items-center">

                        <img src={Apple} className="mr-3" />
                        <img src={Android} />
                    </div>
                </div>
                <div className="col-12 pt-4">
                <div className="footer-head"> <i className="fa fa-map-marker pr-2"></i> Address</div>

                    <div className="text-white">
                        Road No 2, House No 2, Ire-Akari Estate, Oluyole Extension, Ibadan, Oyo State.
                    </div>
                    <div className="text-center pt-2">&copy;2025</div>
                </div>
            </div>
        </footer>
    );
};

